const isNumber = object => typeof object === 'number';
const isString = object => typeof object === 'string';

const cookie = {
  set(name, value, days, path, domain, secure) {
    let expires;
    if (isNumber(days)) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else if (isString(days)) {
      expires = days;
    } else {
      expires = false;
    }
    document.cookie = name + '=' + encodeURIComponent(value) + (expires ? ';expires=' + expires : '') + (path ? ';path=' + path : '') + (domain ? ';domain=' + domain : '') + (secure ? ';secure' : '');
  },
  get(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      } if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  },
};

export default cookie;
